@if (loading()) {
  <div class="inline-flex items-center justify-center w-full h-full">
    <vti-icons [icon]="'spinner'" [size]="20"></vti-icons>
  </div>
} @else {
  <div class="h-52 w-full sm:w-126" #containerBarRef>
    <vti-info-button [investmentProjectId]="investmentProjectId()" [type]="'carbon'">
      <ngx-charts-area-chart
        [view]="[containerBarRef.offsetWidth, containerBarRef.offsetHeight]"
        [scheme]="colorScheme()"
        [legend]="legend()"
        [legendPosition]="legendPosition()"
        [xAxis]="true"
        [yAxis]="true"
        [legendTitle]="legendTitle()"
        [xAxisLabel]="xAxisLabel()"
        [yAxisLabel]="yAxisLabel()"
        [results]="results()"
        [rotateXAxisTicks]="false"
        [xAxisTickFormatting]="tickFormatting"
      >
        <ng-template #tooltipTemplate let-model="model">
          <div class="flex flex-col">
            <span>{{ model.series }} - {{ model.name }}</span>
            <span>{{ model.value | number: '1.2-2' : locale() }}</span>
          </div>
        </ng-template>
        <ng-template #seriesTooltipTemplate let-model="model">
          <span>{{ model[0].series }}: {{ model[0].value | number: '1.2-2' : locale() }}</span>
        </ng-template>
      </ngx-charts-area-chart>
    </vti-info-button>
  </div>
}
